// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"01658bf3","718":"db141529"}[chunkId] + ".chunk.js";
};